import { render, staticRenderFns } from "./PlayerBulkInfrastructureUpgraded.vue?vue&type=template&id=90e4be90&scoped=true&"
import script from "./PlayerBulkInfrastructureUpgraded.vue?vue&type=script&lang=js&"
export * from "./PlayerBulkInfrastructureUpgraded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e4be90",
  null
  
)

export default component.exports